export default __webpack_public_path__ + "static/media/logoWhite.5e64f7fd.png";